<template>
      <div class="modal fade show" id="SeatModal" tabindex="-1" role="dialog" aria-labelledby="basicModal"
    style="padding-right: 17px; background-color: rgba(32, 32, 32, 0.66);" aria-modal="true">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-body logpop">
          <div class="row pad50" style="padding: 15px;">

            <div class="col-md-12">
              <div class="membership marb3">
                <h6 style="font-size: 20px;color: #e8115a;">Notes
                </h6>
                <p style="font-size: 14px;margin-bottom: 10px;">Please read these important terms and conditions for
                  online booking.</p>
                <p class="" style="font-size: 10px;min-height: 100px;overflow-y: scroll;max-height: 150px;"
                  v-html="terms">
                </p>
                <form>
                  <div  style="text-align: right;">
                    <button   class="tim goScreen bg4 text-center tibtn" @click="closeModal('cancel')" data-dismiss="modal"
                      style="padding: 7px 15px;background-color: rgb(254, 187, 23) !important;color: #2b2b2b; text-decoration: none aliceblue !important;"> <span
                        class="linht">Cancel
                      </span>
                    
                    </button> <button  @click="closeModal('Accept')" data-dismiss="modal"
                      class="tim goScreen bg4 text-center tibtn"
                      style="background-image: linear-gradient(135deg,rgba(174,1,94,1) 1%,rgba(222,12,100,1) 16%,rgba(235,18,89,1) 30%,rgba(239,82,69,1) 67%,rgba(244,121,45,1) 83%,rgba(254,187,23,1) 100%);color: aliceblue;padding: 7px 15px;text-decoration: none aliceblue !important;">
                      <span class="linht">Accept
                      </span>
                    </button>
                  </div><!-- end form-group -->


                  <!-- end or -->
                </form>
              </div>
              <!-- end membership -->
            </div>




          </div>



        </div>

      </div>
    </div>
  </div>
  <button id="SeatModal" data-toggle='modal'
                data-target="#SeatModal" style="display: none;">
               </button>
</template>

<script>
import { URL } from '@/conf';
import axios from 'axios';
export default{
  data: () => ({
    terms: null,

  }),
  methods: {

getTerms() {

  axios.get(URL + "Termsandcondition").then((response) => {
    this.terms = response.data.content;
    // document.getElementById('SeatModal').click();
  });
},
closeModal(type){
      // var modalId=document.getElementById('largeModal');
      // modalId.style.display = "none";
      if(type=="Accept"){
      console.log("ACCEPT");
      }
      if(type=="cancel"){
       this.$router.replace({ path: '/' })
      }
      // console.log(modalId);
    },
  },
  created(){
    this.getTerms();
  }
  
  }</script>